module.exports = __webpack_public_path__ + "img/Boss_shibu.77de04b2.png";